export const userGroupRoute = {
  USER_GROUP_LIST: '/user-group/list',
  USER_GROUP_DETAIL: '/user-group/detail/:recordId',
};
